module.exports = __webpack_public_path__ + "img/xUSDC.3b5972c1.svg";